import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import {
    GET_CLIENT_CARTONS,
    GetClientCartonsResponse,
    GetClientCartonsVariables,
} from '../graphql/queries/getClientCartons';

export const useClientCartonQuery = (
    variables: GetClientCartonsVariables,
    skip: boolean = false
) => {
    const queryVariables = useMemo(() => variables, [
        variables.bigBagNo,
        variables.masterWaybillNo,
        variables.channelId,
        variables.arrivePortCode,
        variables.scanWarehouseId,
        variables.hubFilterWarehouseId,
        variables.createdAtFrom,
        variables.createdAtTo,
        variables.scanTimeFrom,
        variables.scanTimeTo,
        variables.pageRequest?.page,
        variables.pageRequest?.size,
    ]);

    const { data, loading, refetch } = useQuery<GetClientCartonsResponse>(
        GET_CLIENT_CARTONS,
        {
            variables: queryVariables,
            fetchPolicy: 'cache-and-network',
            skip,
            notifyOnNetworkStatusChange: true,
        }
    );

    const items = data?.getClientCartons?.items ?? [];
    const totalCount = data?.getClientCartons?.totalCount ?? 0;

    return { items, totalCount, loading, refetch };
};
